import { GroupBase, ValueContainerProps } from 'react-select';
import styled from 'styled-components';

import { AccountOption } from '../types';

type Props = ValueContainerProps<
  AccountOption,
  false,
  GroupBase<AccountOption>
>;

export default function CustomValueContainer({ children, ...props }: Props) {
  return (
    <Container {...props} className="select-value-container">
      {children}
    </Container>
  );
}

const Container = styled.div.withConfig<Props>({
  shouldForwardProp: (prop) => ['className', 'children'].includes(prop),
})`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-flex;
  align-items: center;
  padding: 0 5px;

  & > div {
    position: relative;
    transform: none;
    max-width: none;
  }
`;
